import type { VoiceScopeAddOptionCommand, VoiceScopeCommand, VoiceScopeSetTaskValueCommand } from './voiceScopeTypes';

const formatAmount = (value: number, valueType: string): string => valueType === 'usd' ? `$${value}` : `${value}`;

/** Spoken quantity and price the add will write, so the confirm row shows them before Apply. */
const addAmounts = ({ quantity, spokenPrice }: VoiceScopeAddOptionCommand): string => {
  const amounts = [
    quantity != null ? `qty ${quantity}` : undefined,
    spokenPrice != null ? formatAmount(spokenPrice, 'usd') : undefined,
  ].filter(Boolean);
  return amounts.length > 0 ? ` · ${amounts.join(' · ')}` : '';
};

const buildAddOptionSummary = (command: VoiceScopeAddOptionCommand): string => {
  const work = command.lineItemName && command.lineItemName !== command.optionName
    ? `${command.optionName} › ${command.lineItemName}`
    : command.optionName;
  return `Add: ${command.taskName} › ${work}${addAmounts(command)}`;
};

const buildSetTaskValueSummary = (command: VoiceScopeSetTaskValueCommand): string =>
  `Update: ${command.taskName}: ${command.valueLabel} → ${formatAmount(command.value, command.valueType)}`;

/** One command's confirm-row line, including the value it will write. */
export const buildCommandSummary = (command: VoiceScopeCommand): string =>
  command.type === 'addOption' ? buildAddOptionSummary(command) : buildSetTaskValueSummary(command);

/** A proposal's confirm-row text: one line per command. */
export const buildProposalSummary = (commands: VoiceScopeCommand[]): string => commands.map(buildCommandSummary).join('; ');
